import type { TGetSimulacoesRelacionadas } from '@/features/simulador/interfaces/simulacao.type'
import { SelecaoAcessorioPropostaValidador } from '@/features/simulador/utils/selecao-acessorio-proposta-validador'
import type { SelecaoProdutoPropostaValidadorBase } from '@/features/simulador/utils/selecao-produto-proposta-validador-base'
import { SelecaoUnidadePropostaValidador } from '@/features/simulador/utils/selecao-unidade-proposta-validador'

type TSelecaoProdutoPropostaFactory = {
  simulacoes: TGetSimulacoesRelacionadas['relacionadas']
  simulacaoSelecionada: TGetSimulacoesRelacionadas['relacionadas'][number]
  tipoProdutoSimulacaoDoSimulador: TGetSimulacoesRelacionadas['simulacaoPrincipal']['tipoDoProduto']
}

export class SelecaoProdutoPropostaFactory {
  static create({
    tipoProdutoSimulacaoDoSimulador,
    simulacoes,
    simulacaoSelecionada,
  }: TSelecaoProdutoPropostaFactory): SelecaoProdutoPropostaValidadorBase {
    switch (tipoProdutoSimulacaoDoSimulador) {
      case 'Unidade':
        return new SelecaoUnidadePropostaValidador({ simulacoes, simulacaoSelecionada })
      case 'Acessorio':
        return new SelecaoAcessorioPropostaValidador({ simulacoes, simulacaoSelecionada })
      default:
        throw new Error(`Tipo de produto desconhecido: ${tipoProdutoSimulacaoDoSimulador}`)
    }
  }
}
